import { createFileRoute } from '@tanstack/react-router';
import { CAMPAIGN_PAGE_SECTION_KEYS, type CampaignPageSectionKey } from '@repo/shared/marketing';
import { LandingEditorPage } from '@/features/marketing';

interface LandingEditorSearch {
  /** Bring this card into view on open (e.g. `?section=form` from the Automations editor's "Edit form"). */
  section?: CampaignPageSectionKey;
  /** `1` right after the one-screen create: run the AI build once on open (consumed by the editor). */
  build?: 1;
}

/** Landing page editor — `/marketing/campaigns/{id}/landing` (focused screen, not nested in the hub). */
export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns_/$campaignId_/landing')({
  validateSearch: (search: Record<string, unknown>): LandingEditorSearch => ({
    section: (CAMPAIGN_PAGE_SECTION_KEYS as readonly unknown[]).includes(search.section)
      ? (search.section as CampaignPageSectionKey)
      : undefined,
    build: search.build === 1 || search.build === '1' ? 1 : undefined,
  }),
  component: LandingEditorRoute,
});

function LandingEditorRoute() {
  const { orgId, campaignId } = Route.useParams();
  const { section, build } = Route.useSearch();
  return <LandingEditorPage orgId={orgId} campaignId={campaignId} initialSection={section} buildOnOpen={build === 1} />;
}
